import { VolumeOffOutlined } from "@mui/icons-material";
import { Box, Typography } from "@mui/material";
import { useLiveQuery } from "@tanstack/react-db";
import { useContext } from "react";

import { TestIds } from "@storyboard/web-test-ids/testIds";
import ContextualFooter from "@/components/ContextualFooter";
import SessionRecorderFooter from "@/components/SessionRecorderFooter/Index";
import { fetchFeedCommandAliasesQuery } from "@/models/repositories";
import { CurrentFeedContext } from "@/models/StateProviders/currentFeedProvider";
import { WorkspaceContext } from "@/models/StateProviders/workspaceProvider";
import { UxContext } from "@/models/UxStateProvider";

export default function FeedFooter() {
  const { userReadOnlyMode } = useContext(UxContext);
  const { currentFeed, haveWritePermission } = useContext(CurrentFeedContext);
  const { currentWorkspaceId } = useContext(WorkspaceContext);
  const canRecordOrUpload = haveWritePermission;
  const isSilentChannel = currentFeed?.isSilent;

  const commandAliases =
    useLiveQuery((q) => (currentFeed?.id ? fetchFeedCommandAliasesQuery(currentFeed.id)(q) : null)).data ?? [];
  const commandAlias = commandAliases?.[0];

  if (canRecordOrUpload && !userReadOnlyMode) {
    return (
      <SessionRecorderFooter
        workspaceId={currentWorkspaceId}
        feedId={currentFeed?.id}
        aliasOwnerAccountId={commandAlias?.id}
      />
    );
  }

  return (
    <ContextualFooter sx={{ height: isSilentChannel ? 64 : 34 }}>
      <Box component="span" data-sb={TestIds.feed.footerMessage}>
        {userReadOnlyMode ? "You are in Read Only mode" : "You are a listener in this channel"}
      </Box>
      {isSilentChannel ? (
        <Box sx={{ display: "flex", alignItems: "center" }}>
          <VolumeOffOutlined role="presentation" sx={{ pr: 0.5 }} />
          <Typography sx={{ fontSize: "12px", fontStyle: "italic", fontWeight: 500 }}>Hands-free is off</Typography>
        </Box>
      ) : null}
    </ContextualFooter>
  );
}
